export default {
    setQueryBUilderTypesInfo(state, payload){
        state.types = payload;
    },

    setQueryBuiderQueryParamters(state, payload){
        state.queryParameters = payload;
    },

    setColumnsRequiredInQueryBuilder(state, payload){
        state.columnsRequired = payload;
    }
};
